import { Button, Popover } from "antd";
import ReactEmojiPicker from "emoji-picker-react";
import { StyledPopoverContent } from "../styles";
import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendWebSocketMessage } from "../../../../store/chats/slice";
import {
  selectSelectedTenantId,
  selectUser,
} from "../../../../store/user/selectors";
import { nanoid } from "@reduxjs/toolkit";
import { PlusOutlined } from "@ant-design/icons";

const reactionsEmoji = ["👍", "❤️", "😂", "😮", "👀"];

const MessageReactions = ({ message, reactions }) => {
  const [open, setOpen] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const user = useSelector(selectUser);
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const dispatch = useDispatch();

  const onClickReaction = useCallback(
    (emoji) => {
      const payload = {
        action: "updateReaction",
        data: {
          message_id: message?.id,
          sender_id: user?.user_id,
          emoji,
          sender_type: "customer",
          clientMessageId: nanoid(),
        },
        conversation_id: message?.conversation_id,
        tenant_id: selectedTenantId,
      };
      //@ts-ignore
      dispatch(sendWebSocketMessage(payload));
      setOpen(false);
      setShowEmojiPicker(false);
    },
    [message, user, selectedTenantId, dispatch],
  );

  const selectedReaction = useMemo(() => {
    return reactions?.find((e) => user?.user_id === e?.sender_id);
  }, [reactions, user]);

  return (
    <div
      className={`message-reactions-div`}
      style={{ display: open ? "flex" : "none" }}
    >
      <Popover
        content={
          <StyledPopoverContent className="reaction-div">
            {showEmojiPicker ? (
              <div className="emoji-picker-container">
                <ReactEmojiPicker
                  onEmojiClick={(e) => {
                    onClickReaction(e.emoji);
                  }}
                  height={350}
                  width={300}
                  previewConfig={{ showPreview: false }}
                  searchDisabled={window.innerWidth <= 768}
                  skinTonesDisabled={window.innerWidth <= 768}
                />
              </div>
            ) : (
              <>
                {[
                  ...reactionsEmoji,
                  ...(selectedReaction?.emoji &&
                  !reactionsEmoji.includes(selectedReaction?.emoji)
                    ? [selectedReaction?.emoji]
                    : []),
                ].map((e) => (
                  <span
                    className={`reaction-span ${selectedReaction?.emoji === e ? "selected" : ""}`}
                    onClick={() => onClickReaction(e)}
                  >
                    {e}
                  </span>
                ))}
                <span
                  className="reaction-span plus-emoji cursor-pointer"
                  onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                  style={{ fontSize: "20px" }}
                >
                  <PlusOutlined />
                </span>
              </>
            )}
          </StyledPopoverContent>
        }
        trigger="click"
        rootClassName="reaction-popover"
        open={open}
        onOpenChange={setOpen}
      >
        <Button
          icon={<span>😊</span>}
          size="small"
          type="text"
          className="reaction-button"
        />
      </Popover>
    </div>
  );
};

export default MessageReactions;
